export type FooterActiveMenuState = {
  [key: string]: boolean;
};

export const footerActiveMenuReducer = (state: FooterActiveMenuState, action: string) => ({
  ...state,
  [action]: !state[action],
});
